import React from "react";
import PropTypes from "prop-types";
import { ContentModal } from "../Layout/templates";
import { getCalculatorTitle } from "../../constants/calculators";
import BsaCalcApp from "../../features/calculator/BsaCalcApp";
import CrcCalcApp from "../../features/calculator/CrcCalcApp";
import IbwCalcApp from "../../features/calculator/IbwCalcApp";
import LbwCalcApp from "../../features/calculator/LbwCalcApp";
import GfrCalcApp from "../../features/calculator/GfrCalcApp";
import AbxCalcApp from "../../features/calculator/AbxCalcApp";

const CalculatorModal = ({ calculatorId, isOpen, onClose }) => {
  const renderCalculator = (calculatorId) => {
    switch (calculatorId) {
      case "ccbwcalc":
        return <CrcCalcApp isWebLayout={true} />;
      case "bsacalc":
        return <BsaCalcApp isWebLayout={true} />;
      case "ibwcalc":
        return <IbwCalcApp isWebLayout={true} />;
      case "lbwcalc":
        return <LbwCalcApp isWebLayout={true} />;
      case "gfrcalc":
        return <GfrCalcApp isWebLayout={true} />;
      case "idcalc":
        return <AbxCalcApp isWebLayout={true} />;
      case "Amikacin":
      case "Gentamicin":
      case "Tobramycin":
        return <AbxCalcApp currentPath={calculatorId} isWebLayout={true} />;
      default:
        return <div>Calculator not found</div>;
    }
  };

  return (
    <ContentModal
      contentId={calculatorId}
      isOpen={isOpen}
      onClose={onClose}
      getContentTitle={getCalculatorTitle}
      renderContent={renderCalculator}
    />
  );
};

CalculatorModal.propTypes = {
  calculatorId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CalculatorModal;
